module.exports = __webpack_public_path__ + "img/alfred.2fc62e2f.svg";